import React from 'react';
import './Bullet.css';
import checkIcon from '../../assets/check.svg';
import { getIcon, ICONS } from '../../icons';
import { COLOURS } from '../../colours';

const Bullet = ({ title, description }) => (
  <li className="bullet">
    {/* <img src={checkIcon} alt="" width={20} height={20} /> */}
    { getIcon( ICONS.SHUTTLEOPS_SHUTTLE, false, { kit: true, size: 40, primary: COLOURS.PRIMARY } ) }
    <div>
      <span className="bullet-title">{title}</span>
      <span className="bullet-desc">{description}</span>
    </div>
  </li>
);

export default Bullet;
